import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { KeyValue } from '@angular/common';
import { FormControl, FormGroup, FormGroupName, MaxLengthValidator, UntypedFormGroup,Validators } from '@angular/forms';
import { distinctUntilChanged, startWith, takeLast, takeUntil } from 'rxjs/operators';
import { StructureTagService } from 'src/app/services/structureTag.service';
import { FormsModule } from '@angular/forms';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { AlertQueryeditorComponent } from 'src/app/alerts/alert-query-editor/alert-query-editor.component';
import { Subject } from 'rxjs';
import { QueryEditorService } from 'src/app/language-service/query-editor.service';
import { forwardRef } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryTokensProviderService } from 'src/app/language-service/query-tokens-provider.service';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { EditorView } from 'codemirror';
import { SharedService } from 'src/app/services/shared.service';
import { Compartment } from "@codemirror/state";


@Component({
  selector: 'app-auto-closure-action',
  templateUrl: './auto-closure-action.component.html',
  styleUrls: ['./auto-closure-action.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutoClosureActionComponent),
      multi: true
    }
  ]
})
export class AutoClosureActionComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  // actionWindow: string = "flagged_for_review"
  // stateWindow: string="True positive"
  actionWindow ='notification'
  action: string
  reasonstate: string
  reason: string
  commentStr: string = ""
  tagsSearchcontrol = new FormControl();
  // timeEmit:any
  // stepEmit:any
  mockClosureAction

  @ViewChild('editorContainer', { static: true }) editorContainer: ElementRef<HTMLElement>;

  @Input() condition;
  @Input() platform_plugins;
  @Input() ruleInfo
  @Input() dropDownIndex
  readonly: boolean = false;
  @ViewChild(AlertQueryeditorComponent) editorchild: AlertQueryeditorComponent;
  errstr: string = '';
  selectedItem: any;
  // testResultVolume: any;
  testResultActionable: any;
  testResultNoise: any;
  alertsLabel: any;
  percentLabel: any;
  alertId: any;
  disabled: boolean = false;
  tagvalue = {}
  enginequery = {}
  MetaAction: any
  querystr
  editor
  queryValid:boolean=false
  showError:boolean=false
  destroy$: Subject<boolean> = new Subject();
  selectedAction
  actionComments=''
  editableCompartment = new Compartment();

  runtest={}

  communications= new FormGroup({
    method : new FormControl(),
    phone: new FormGroup({
      country_code: new FormControl('+91'),
      number: new FormControl(),
      message: new FormControl()
    }),
    email: new FormGroup({
      mail_id: new FormControl(),
      subject: new FormControl(),
      mail_body: new FormControl()
    })
  })
  // timeframevalue:any=3600
  // stepsizevalue:any=3600
  // valuerange:any
  // min:number
  // max:number
  // step:any[]


  // ControlValueAccessor implementation
  onChange = (value: any) => { };
  onTouched = () => { };
  builtInquery: any = ""
  editorValueSubject = new Subject<string>();
  $destroy: Subject<boolean> = new Subject();

  constructor(
    public alertvarservice: AlertsvarService,
    private structureTags: StructureTagService,
    public alertservice: AlertsService,
    private queryEditorService: QueryEditorService,
    private querytokenprovider: QueryTokensProviderService,

    private sharedService: SharedService
  ) { }

  async ngOnInit() {
    // console.log("RuleInfo ->", this.ruleInfo)



//console.log("Condition -->",this.condition)

    setTimeout(() => {
      this.changeAction('notification')
      this.method.setValue('phone')
    }, 500);

    // console.log(this.mockClosureAction)

    if(this.alertvarservice.editState){
      this.setActionValuesEdit()
    }else{
      this.setActionValues()
    }
   
        // this.mockClosureAction = JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction)))


    
    
    // if(this.alertvarservice._ruleType.value == "auto_closure"){
    //   // console.log(this.mockClosureAction)
    //   let arr=[]
    //   JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
    //     // console.log(data)
    //     if(data.disp == "Close"){
    //       arr.push(data)
    //     }
    //   })
    //   this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    // }else if(this.alertvarservice._ruleType.value == "auto_investigate"){
    //   this.mockClosureAction = JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction)))
    // }else if(this.alertvarservice._ruleType.value == "direct_to_signal"){
    //   let arr=[]
    //   JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
    //     if(data.disp == "Signal"){
    //       arr.push(data)
    //     }
    //   })
    //   this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    // }


    this.builtInquery = this.condition.actions.query;
    // console.log(this.platform_plugins)
    await this.createeditor(this.builtInquery, this.platform_plugins);
    this.editorValueSubject.pipe(takeUntil(this.$destroy)).subscribe((value) => {
      this.condition.actions.query = value
      this.queryValid=false

//console.log({value})
      if(this.condition.actions.condition === 'else'){
        if(value){
          this.condition.actions.isValid=false
        }else{
          this.condition.actions.isValid=true
        }
      }else{
        this.condition.actions.isValid=false
      }

    })
    if (this.alertvarservice.editState) {
      
      // this.alertvarservice.actionWindow = this.alertvarservice.ruleForm.value.actions.actionname
      this.actionWindow = this.alertvarservice.ruleForm.value.actions.actionname

      this.alertvarservice.stateWindow = this.alertvarservice.ruleForm.value.actions.closurestate.statename

      // console.log("EditCheck------->",this.alertvarservice.actionWindow,"\n",this.alertvarservice.stateWindow,"\n",this.alertvarservice.closureAction1)

      this.action = this.alertvarservice.ruleForm.value.actions.actionname
      this.reasonstate = this.alertvarservice.ruleForm.value.actions.closurestate.statename
      this.reason = this.alertvarservice.ruleForm.value.actions.closurestate.closurereason

      // this.actionname.setValue(this.alertvarservice.ruleForm.value.actions.actionname)
      // this.statename.setValue(this.alertvarservice.ruleForm.value.actions.closurestate.statename)
      // this.closurereason.setValue(this.alertvarservice.ruleForm.value.actions.closurestate.closurereason)

      // // console.log("In OnInit",this.action, "\n", this.reasonstate, "\n", this.reason)
    }
    else {
      // this.timeframe.setValue(3600)
      // this.stepsize.setValue(3600)
    }
    // console.log("statename",this.statename)
    // this.closurereason.setValue('Malware Infection')

    if (this.alertvarservice.editState) {
      // if(this.alertvarservice.editrequested.value.conditions[0].actions.action==="flagged_for_review"){
      //   this.alertvarservice.closureAction1.flagged_for_review.state=1
      //   this.alertvarservice.closureAction.no_action_required.state = 0
      // }
      // else if(this.alertvarservice.editrequested.value.conditions[0].actions.action==="close"){
      //   this.alertvarservice.closureAction1.close.state=1
      //   this.alertvarservice.closureAction.no_action_required.state = 0
      // }
      // this.alertvarservice.closureAction.no_action_required.state = 0
      // this.alertvarservice.closureAction1[this.alertvarservice.editrequested.value.conditions[0].actions.action]["state"]=0
    }
    if (this.alertvarservice.editState) {
      this.alertId = this.alertvarservice.editrequested.value.ruleFor

    } else {
    }
    // this.alertvarservice.$alert.subscribe(value => {
    //   // console.log('alert>>>>>>>>>', value);
    //   // this.setLanguageGrammar(value["platform"], this.alertId)
    //   this.alertId = value["alertId"]
    // });



    // // console.log("RuleForm- 02--->",this.alertvarservice.ruleForm)
    // console.log("Mock Closure Action --->",this.alertvarservice.mockClosureAction)
    if (!this.alertvarservice.editState) {
      // this.actionclick(1)
      
    }else{
      // setTimeout(() => {
      //   console.log(this.mockClosureAction)
      // }, 500);
     
      this.restructureEdit()
    
      setTimeout(() => {
        this.verifyqueryClick()
      },1500);
    }
  }



  ngAfterViewInit() {

   
   
    this.communications.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(com=>{
      // this.condition.actions.isValid= true
      // console.log(this.communications)

      // console.log(this.condition.actions)
      
      this.condition.actions.communications=this.communications.getRawValue()
      // if(this.communications.valid && this.queryValid){
      //   this.condition.actions.isValid= true
      // }else{
      //   if(!this.communications.pristine){
      //     this.condition.actions.isValid=false
      //   }
      // }

      if(this.condition.actions.condition === 'else'){
        if(this.condition.actions.query.length !=0){
          // if(this.communications.valid){
          //   this.condition.actions.isValid= true
          // }else{
          //   if(!this.communications.pristine && !this.condition.actions.reason && this.condition.actions.reason !=0){
          //     this.condition.actions.isValid=false
          //   }
          // }
          if((this.communications.pristine || this.communications.valid) && (this.condition.actions.reason || this.condition.actions.reason == 0)){
            this.condition.actions.isValid=true
          }else{
            this.condition.actions.isValid= false
          }
        }else{
          this.condition.actions.isValid= true
        }
      }else{
        if(this.communications.valid && this.queryValid && (this.condition.actions.reason || this.condition.actions.reason == 0)){
          this.condition.actions.isValid= true
        }else{
          if(!this.communications.pristine){
            this.condition.actions.isValid=false
          }
        }
      }
      // console.log(this.communications.getRawValue())
      if(this.method.value == 'phone'){
        if(!this.phone.get('number').value && !this.phone.get('message').value){
          this.communications.markAsPristine()
          this.communications.markAsUntouched()
        }
        
      }
      else if(this.method.value == 'email'){
       
        if(!this.email.get('mail_id').value && !this.email.get('mail_body').value){
          this.communications.markAsPristine()
          this.communications.markAsUntouched()
        }
      }
    })

 

    this.method.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(method=>{
      
      // console.log(method)
      // console.log(this.actions)
      if(method == "phone"){
        this.phoneValidators()
      }else if(method == "email"){
        this.subject.setValue(this.ruleInfo.description)
        this.emailValidators()
      }
    })

    this.email.get('mail_body').valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
//console.log({data})
//console.log(this.email.get('mail_id').value,this.email.get('mail_id').valid)
      if(data){
        if(!this.email.get('mail_id').value){
//console.log("No Mail ID")
          this.email.get('mail_id').setValidators(Validators.required)
          this.email.get('mail_id').updateValueAndValidity()
        }
      }else{
        this.email.get('mail_id').setValidators(null)
        this.email.get('mail_id').updateValueAndValidity()
      }
    })

    this.phone.get('message').valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
    
      if(data){
        if(!this.phone.get('number').value){
          this.phone.get('number').setValidators(Validators.required)
          // this.phoneValidators()
          this.phone.get('number').updateValueAndValidity()
        }
      }else{
        this.phone.get('number').setValidators(null)
        this.phone.get('number').updateValueAndValidity()
      }
    })
    this.phone.get('number').valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
      this.phoneValidators()
    })
    this.email.get('mail_id').valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
      this.emailValidators()
    })

    // this.timeframe.valueChanges.subscribe((data)=>{
    //   this.timeframevalue=data
    //   this.timeEmit=data
    //   this.action=this.alertvarservice.ruleForm.value.actions.actionname
    //   this.reasonstate=this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //   this.reason=this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
    //   this.commentStr=this.alertvarservice.ruleForm.value.actions.comments

    //   // // console.log(this.rulevarservice.timeframe)
    //   // // console.log(this.rulevarservice.timeframe[0].range[0].min)
    //   if(this.timeframevalue < this.stepsizevalue){
    //     // // console.log("ErrorType",this.rulevarservice.errorState[1])
    //     // // console.log(this.rulevarservice.errorType[102])
    //     // this.errstr=this.rulevarservice.errorType[102]
    //     // // this.rulevarservice.isInvalid=true
    //     // this.rulevarservice.errorState[1] = true;
    //     // // console.log("ErrorType",this.rulevarservice.errorState[1])
    //   }
    //   else{
    //     // this.rulevarservice.errorState[1] = false;
    //   }
    //   this.valuerange = this.alertvarservice.timeframe.find(list => list.value === this.timeframevalue);
    //   // console.log("Range",this.valuerange?.range[0]); 
    //   this.min=this.valuerange?.range[0]?.min
    //   this.max=this.valuerange?.range[0]?.max
    //   // this.rulevarservice.stepsize=this.rulevarservice.timeframe
    //   // console.log("Step---->",typeof(this.step))
    //   // this.step[0]
    //   this.step=[]
    //   Object.values(this.alertvarservice.stepsize1).forEach(value => {
    //     if(value.value>=this.min && value.value<=this.max)
    //       // // console.log(value)
    //       this.step.push(value)
    //   });
    //   this.alertvarservice.stepsize=this.step
    //   // console.log(this.alertvarservice.stepsize)

    //   this.emitValueChange()

    // })
    // this.stepsize.valueChanges.subscribe((data)=>{
    //   this.stepsizevalue=data
    //   this.stepEmit=data
    //   this.action=this.alertvarservice.ruleForm.value.actions.actionname
    //   this.reasonstate=this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //   this.reason=this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
    //   this.commentStr=this.alertvarservice.ruleForm.value.actions.comments
    //   this.emitValueChange()

    //   // if(this.timeframevalue < this.stepsizevalue){
    //   //   // console.log("ErrorType",this.rulevarservice.errorState[1])
    //   //   // console.log(this.rulevarservice.errorType[102])
    //   //   this.errstr=this.rulevarservice.errorType[102]
    //   //   // this.rulevarservice.isInvalid=true
    //   //   this.rulevarservice.errorState[1] = true;
    //   //   // console.log("ErrorType",this.rulevarservice.errorState[1])
    //   // }
    //   // else{
    //   //   this.rulevarservice.errorState[1] = false;
    //   //   this.errstr=""
    //   // }


    // })

    // this.queryEditorService.editorValue$.subscribe(data=>{
    //   // // console.log("Query Live Changes====---~~~",data)
    //   // // console.log("Alert Rule",this.queryEditorService.get_editor_value(this.editor))

    //   setTimeout(() => {
    //       if(this.querytokenprovider.parseTokens(this.editor)['SearchCommand']){
    //       console.log("Raw Value --->",this.alertvarservice.autoInvestigate.getRawValue())
    //       console.log("Tokens ---->",this.querytokenprovider.parseTokens(this.editor)['SearchCommand'])
    //     this.enginequery=this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor)['SearchCommand'])
    //     // console.log("Engine Query------->",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor).searchTokens))
    //     }
    //   }, 500);

    //   // // console.log("RuleForm-OnChanges--->",this.alertvarservice.ruleForm)

    //     this.action=this.alertvarservice.ruleForm.value.actions.actionname
    //     this.reasonstate=this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //     this.reason=this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
    //     this.commentStr=this.alertvarservice.ruleForm.value.comments
    //     // // console.log("OnQueryValueChanges---->",this.action,"-->",this.reasonstate,"-->",this.reason)

    //     // console.log("Current Value-->",this.getCurrentValue())
    //     this.emitValueChange()

    // })
    this.queryEditorService.editorValue$.subscribe(data => {
      if (!this.alertvarservice.editState) {
        this.query.setValue(data)
      }
      else {
        if (data.length > 0) {
          this.query.setValue(data)
        }
      }
      this.querystr = data



      // setTimeout(() => {
      // if(this.querytokenprovider.parseTokens(this.editor)['SearchCommand']){
      // this.enginequery['SearchCommand']=this.querytokenprovider.parseTokens(this.editor)['SearchCommand']

      // console.log("Raw Value --->",this.alertvarservice.autoInvestigate.getRawValue())
      // console.log("Tokens ---->",this.querytokenprovider.parseTokens(this.editor)['SearchCommand'])
      // this.enginequery=this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor)['SearchCommand'])
      // console.log("Engine Query------->",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor).searchTokens))
      // }
      // }, 500);

      //console.log("Query Live Changes====---~~~", data)
      this.action = this.alertvarservice.ruleForm.value.actions.actionname

      this.reasonstate = this.alertvarservice.ruleForm.value.actions.closurestate.statename
      this.reason = this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
      // this.commentStr = this.alertvarservice.ruleForm.value.comments
      if (data.length > 0) {
        this.enginequery['SearchCommand'] = []
        this.enginequery['SearchCommand'] = this.querytokenprovider.parseTokens(this.editor,'alert')['SearchCommand']
      }
      //console.log("Value Changes EngineQuery ------->",this.enginequery['SearchCommand'])

      // console.log("Current Value-->",this.getCurrentValue())
      setTimeout(() => {
        this.emitValueChange()
      }, 0);

      //console.log("Auto Investigate ---->",this.query.value)
    })

    // this.query.valueChanges.subscribe(data=>{
    //   console.log("Query Live--- >",data)
    //   // this.verifyquery()
    //   // this.queryEditorService.set_editor_value(this.editor,data),{ emitEvent: false }
    //   // console.log(this.queryEditorService.get_editor_value(this.editor))
    //   // // console.log("Conditions 5.2",this.alertvarservice.autoInvestigate.value.conditions)
    //   // if(data.length>0){
    //     // this.enginequery=this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor).searchTokens)
    //     // // console.log("Engine Query------->",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor).searchTokens))

    //     // setTimeout(() => {

    //     // }, 0);
    //     // console.log("RuleForm--->",this.alertvarservice.ruleForm.value)
    //     this.action=this.alertvarservice.ruleForm.value.actions.actionname
    //     this.reasonstate=this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //     this.reason=this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
    //     this.commentStr=this.alertvarservice.ruleForm.value.comments
    //     // console.log("Current Value-->",this.getCurrentValue())
    //     this.emitValueChange()

    //   // }
    //   // // console.log("Conditions 5.3",this.alertvarservice.autoInvestigate.value.conditions)
    // })

    this.tagsSearchcontrol.valueChanges.pipe(distinctUntilChanged()).subscribe((val: string) => {
      this.alertvarservice.tagsMapping(this.alertvarservice.commondata.tags.mapping)
      this.alertvarservice.tagsSearch(val)
      //console.log("TagsSearchControl>>>>>>>", val)
    });


    this.statename.valueChanges.pipe(distinctUntilChanged()).subscribe((val) => {
      //console.log("statename")
      this.closurereason.setValue("")
      this.action = ""
      this.reasonstate = ""
      this.reason = ""
      Object.keys(this.alertvarservice.closureAction1).forEach(data => {
        this.alertvarservice.closureAction1[data].state = 0
      })
      // this.alertvarservice.closureAction1[this.actionname.value].state=0
      this.emitValueChange()
    })

    this.actionname.valueChanges.pipe(distinctUntilChanged()).subscribe((val) => {
      //console.log("actionname")
      this.closurereason.setValue("")
      this.action = ""
      this.reasonstate = ""
      this.reason = ""
      // // console.log("Action Value Changes")
      Object.keys(this.alertvarservice.closureAction1).forEach(data => {
        this.alertvarservice.closureAction1[data].state = 0
      })
      // this.alertvarservice.closureAction1[this.alertvarservice.actionWindow].state=0
      this.emitValueChange()
    })


    // this.comments.valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
    //   this.condition.actions.comments = val
    //   this.commentStr = val
    //   this.alertservice.alertRules.closure_action.action.value.comments = val
    //   // this.alertvarservice.ruleForm.patchValue({
    //   // comments: val
    //   // comments: val
    //   // },{emitEvent:false});
    //   // console.log("Query Comment 2 --->",this.alertvarservice.autoInvestigate.value.conditions[1].actions)
    //   // this.emitValueChange();

    //   // console.log(val)

    //   // this.query.setValue(this.querystr)

    //   // Emit value changes 
    //   if (this.alertvarservice.editState) {
    //     this.action = this.alertvarservice.ruleForm.value.actions.actionname
    //     this.reasonstate = this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //     this.reason = this.alertvarservice.ruleForm.value.actions.closurestate.closurereason

    //     // if(this.alertvarservice.ruleForm.value.actions.comments.length>0){
    //     // // console.log("Query Comment 2.1 --->",this.alertvarservice.autoInvestigate.value.conditions[1].actions)
    //     this.emitValueChange();
    //     // // console.log("Query Comment 2.2 --->",this.alertvarservice.autoInvestigate.value.conditions[1].actions)
    //     // }
    //   }
    //   else {
    //     this.action = this.alertvarservice.ruleForm.value.actions.actionname
    //     this.reasonstate = this.alertvarservice.ruleForm.value.actions.closurestate.statename
    //     this.reason = this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
    //     //console.log("Query before comment emit ----->",this.query.value)
    //     this.emitValueChange();
    //   }
    //   // // console.log("Query Comment 3 --->",this.alertvarservice.autoInvestigate.value.conditions[1].actions)

    // })
  }

  setActionValues(){
    if(this.alertvarservice._ruleType.value == "auto_closure"){
      // console.log(this.mockClosureAction)
      let arr=[]
      JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
        // console.log(data)
        if(data.disp == "Close"){
          arr.push(data)
        }
      })
      this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    }else if(this.alertvarservice._ruleType.value == "auto_investigate"){
      this.mockClosureAction = JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction)))
    }else if(this.alertvarservice._ruleType.value == "direct_to_signal"){
      let arr=[]
      JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
        if(data.disp == "Signal"){
          arr.push(data)
        }
      })
      this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    }
  }

  setActionValuesEdit(){
    if(this.alertvarservice.editrequested.value.type == "auto_closure"){
      // console.log(this.mockClosureAction)
      let arr=[]
      JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
        // console.log(data)
        if(data.disp == "Close"){
          arr.push(data)
        }
      })
      this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    }else if(this.alertvarservice.editrequested.value.type == "auto_investigate"){
      this.mockClosureAction = JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction)))
    }else if(this.alertvarservice.editrequested.value.type == "direct_to_signal"){
      let arr=[]
      JSON.parse(JSON.stringify(this.restructure(this.alertvarservice.mockClosureAction))).forEach(data=>{
        if(data.disp == "Signal"){
          arr.push(data)
        }
      })
      this.mockClosureAction=JSON.parse(JSON.stringify(arr))
    }
  }

  // ControlValueAccessor 
  writeValue(value: any): void {
    // console.log("writeValue", value)
    if (value) {
      this.selectedItem = value;
      if (value.action) {
        this.action = value.action;
      }
      if (value.state) {
        this.reasonstate = value.state;
      }
      if (value.reason) {
        this.reason = value.reason;
      }
      if (value.comments) {
        this.commentStr = value.comments;
      }
      // Update form controls 
      this.updateFormFromValue(value);
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.tagsSearchcontrol.disable();
    } else {
      this.tagsSearchcontrol.enable();
    }
  }
  // mit value changes
  emitValueChange(): void {
    let currentValue = this.getCurrentValue();
    this.selectedItem = currentValue;
    this.onChange(currentValue);
  }

  commentChange(data){
    this.condition.actions.comments=data
  }

  // get cutrrent value
  getCurrentValue(): any {
    // // console.log("In Current Value",this.action, "\n", this.reasonstate, "\n", this.reason)
    let tag = this.alertvarservice.ruleForm.value.actions.add_tags
    if (this.tagvalue) {
      // tag={tags:this.structureTags.tagarrtoObj(this.structureTags.structureTagPost(this.tagvalue))}
      tag = this.alertvarservice.ruleForm.value.actions.add_tags
    }
    if (this.query.value.length > 0) {
      this.enginequery['SearchCommand'] = []
      this.enginequery['SearchCommand'] = this.querytokenprovider.parseTokens(this.editor,'alert')['SearchCommand']
      //console.log("Engine Query before Emitting ========-------->",this.enginequery['SearchCommand'])
    }
    if (this.alertvarservice.actionWindow === "no_action_required") {
      return {
        action: this.alertvarservice.actionWindow,
        state: null,
        reason: null,
        comments: null,
        category: null,
        // tags: Array.from(this.alertvarservice.tagsSet || []),
        add_tags: tag,
        // actionWindow: this.actionWindow,
        // stateWindow: this.stateWindow,
        query: this.query.value,
        tokens: JSON.parse(JSON.stringify(this.enginequery)),
        // timeframe: this.timeEmit,
        // stepsize:this.stepEmit

      };
    }
    else {
      //   return {
      //   action: this.action,
      //   state: this.reasonstate,
      //   reason: this.reason,
      //   comments: this.commentStr,
      //   // tags: Array.from(this.alertvarservice.tagsSet || []),
      //   add_tags:tag,
      //   // actionWindow: this.actionWindow,
      //   // stateWindow: this.stateWindow,
      //   query: this.query.value,
      //   engineQuery:this.enginequery,
      //   // timeframe: this.timeEmit,
      //   // stepsize:this.stepEmit
      // };
      return {
        action: this.alertvarservice.clickedAction,
        state: this.alertvarservice.clickedState,
        category: this.alertvarservice.clickedReason,
        reason: this.alertvarservice.clickedStateReason,
        comments: this.commentStr,
        add_tags: tag,
        query: this.query.value,
        tokens: JSON.parse(JSON.stringify(this.enginequery)),

      };
    }

  }

  // update action values
  updateFormFromValue(value: any): void {
    if (value.action && value.state && value.reason) {
      this.alertvarservice.ruleForm.patchValue({
        query: value.query,
        actions: {
          actionname: value.action,
          closurestate: {
            statename: value.state,
            closurereason: value.reason,
          },
          // comments: value.comments || ''
        },
        comments: value.comments || ''
      });
    }
  }

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  get tags() {
    return this.add_tags.get('tags');
  }
  get add_tags() {
    return this.actions.get('add_tags') as UntypedFormGroup;
  }
  get actions() {
    return this.alertvarservice.ruleForm.get('actions') as UntypedFormGroup;
  }
  get state_reason() {
    return this.actions.get('state_reason') as UntypedFormGroup;
  }

  get actionname() {
    return this.actions.get('actionname')
  }

  get closurestate() {
    return this.actions.get('closurestate') as UntypedFormGroup;
  }

  get statename() {
    return this.closurestate.get('statename')
  }
  get closurereason() {
    return this.closurestate.get('closurereason')
  }
  // get comments() {
  //   return this.alertvarservice.ruleForm.get('comments')
  // }
  // get timeframe(){
  //   return this.alertvarservice.ruleForm.get("timeframe")
  // }

  // get stepsize(){
  //   return this.alertvarservice.ruleForm.get("stepsize")
  // }

  changeAction(actionKey: any) {

//console.log(actionKey)

    // console.log("After Tags set---->",this.alertvarservice.ruleForm.value.actions.add_tags)


    if (actionKey === "no_action_required") {
      this.alertvarservice.clickedAction = ''
      this.alertvarservice.clickedState = ''
      this.alertvarservice.clickedReason = ''
      this.alertvarservice.clickedStateReason = ''
      this.alertvarservice.openComments = false
      // console.log("No_Action_Required!!!!!!!")
      // this.alertvarservice.closureAction.no_action_required.state = 1
      Object.keys(this.alertvarservice.closureAction1).forEach(data => {
        this.alertvarservice.closureAction1[data].state = 0
      })
      // this.alertvarservice.closureAction1.flagged_for_review.state=0
      // this.alertvarservice.closureAction1.close.state=0
      // this.alertvarservice.closureAction.add_tags.state = 0
      // this.alertvarservice.closureAction.execute_cmd.state = 0
      this.alertvarservice.closureAction.notification.state = 0
      // this.statename.setValue('')
      this.alertvarservice.actionWindow = actionKey
      this.actionWindow = actionKey
      this.alertvarservice.stateWindow = null
    }
    this.alertvarservice.actionWindow = actionKey
    this.actionWindow = actionKey
    // console.log(this.alertvarservice.actionWindow, "///////////")
    // this.onTouched(); 
    // console.log("Before Tag Emit==>",this.alertvarservice.ruleForm.value.actions.add_tags)
    // this.emitValueChange();
  }

  changeStateAction(actionKey: any, stateKey: any, event: Event) {
    // console.log("ChangeStateAction",this.alertvarservice.closureAction1)
    this.alertvarservice.actionWindow = actionKey
    this.actionWindow = actionKey
    this.alertvarservice.stateWindow = stateKey

    // console.log("Loop",this.alertvarservice.closureAction1[this.alertvarservice.actionWindow].state_action[this.alertvarservice.stateWindow].reason)
    // console.log("StateNameCheck",this.alertvarservice.closureAction1[this.alertvarservice.actionWindow])
    // console.log("statenamevalue",this.statename.value)
    this.alertvarservice.actionWindow = actionKey
    this.actionWindow = actionKey
    this.alertvarservice.stateWindow = stateKey

    this.alertvarservice.ruleForm.patchValue({
      actions: {
        actionname: actionKey,
        closurestate: {
          statename: stateKey,
        }
      }
    });


    // console.log(this.alertvarservice.actionWindow, "///////////")
    // console.log(this.alertvarservice.stateWindow, "///////////")
    this.onTouched();
    this.emitValueChange();
  }

  stateClick(action: string, state: string, value: string) {
    // console.log("StateClick----->",action, "->", state, "->", value)
    // console.log("CurrentValues-->",this.action,"->",this.reasonstate,"->",this.reason)
    this.closurereason.setValue(value)
    // this.alertvarservice.closureAction.no_action_required.state = 0
    if (action === this.action) {
      // // console.log("Action===ACTION")
      if (state != this.reasonstate || value != this.reason) {
        // // console.log("Inside If")

        this.action = action
        this.reasonstate = state
        this.reason = value

        this.alertservice.alertRules.closure_action.action.type = action
        this.alertservice.alertRules.closure_action.action.value.state.type = state
        this.alertservice.alertRules.closure_action.action.value.state.value.reason = value



        this.alertvarservice.ruleForm.patchValue({
          actions: {
            actionname: action,
            closurestate: {
              statename: state,
              closurereason: value,
            }
          }
        });
        this.action = action
        this.reasonstate = state
        this.reason = value

        // console.log("Ruleform After Patch---->",this.alertvarservice.ruleForm.value)
        this.alertvarservice.closureAction1[action].state = 1;

        // console.log("After patch--->",this.action, "\n", this.reasonstate, "\n", this.reason)
        // console.log(this.alertvarservice.closureAction1[action].state)
      }
      else {
        // console.log("Condition False------>")
        this.alertvarservice.closureAction1[this.action].state = 0;
        this.action = ''
        this.reasonstate = ''
        this.reason = ''
        this.alertvarservice.ruleForm.patchValue({
          actions: {
            actionname: this.action,
            closurestate: {
              statename: this.reasonstate,
              closurereason: this.reason,
            }
          }
        });
      }
    } else {
      // console.log("Condition False and have Action ------>")
      if (this.action) {

        this.alertvarservice.closureAction1[this.action].state = 0;
      }

      this.alertvarservice.closureAction1[action].state = 1;
      this.action = action
      this.reasonstate = state
      this.reason = value
      this.alertservice.alertRules.closure_action.action.type = action
      this.alertservice.alertRules.closure_action.action.value.state.type = state
      this.alertservice.alertRules.closure_action.action.value.state.value.reason = value





      this.alertvarservice.ruleForm.patchValue({
        actions: {
          actionname: action,
          closurestate: {
            statename: state,
            closurereason: value,
          }
        }
      });

      this.action = action
      this.reasonstate = state
      this.reason = value
      this.alertvarservice.closureAction1[action].state = 1;


      // console.log(this.action, "\n", this.reasonstate, "\n", this.reason)
      // console.log(this.alertvarservice.closureAction1[action].state)
    }
    if (!this.action) {
      // this.alertvarservice.closureAction.no_action_required.state = 1
      // this.alertvarservice.closureAction1[this.action].state = 0;
    }
    // console.log("State------>",this.alertvarservice.closureAction1[action].state)
    // console.log("ClosureForm", this.alertvarservice.ruleForm)

    this.onTouched();
    this.emitValueChange();  // emit values
  }

  conditionfromeditor(conditionstr: string) {
    this.query.setValue(conditionstr.replace(/\n/g, ''));
    this.query.setValue(conditionstr);
  }

  get query() {
    return this.alertvarservice.ruleForm.get('query')
  }
  verifyqueryClick(){ // verify Query
//console.log(this.querytokenprovider.parseTokens(this.editor,'alert'))
    this.runtest={}
    if (this.queryEditorService.isEditorError(this.editor)) {
     
      if(this.condition.actions.condition === 'else'){
        if(this.condition.actions.query.length == 0){
//console.log("Length Empty")
          this.queryValid=true
        }else{
          this.queryValid=false
        }
      }else{
        this.queryValid=false
      }
      
      this.showError = false
//console.log("-->",this.condition)
    }else{
      this.queryValid=true
      // console.log(this.querytokenprovider.parseTokens(this.editor,'alert'))
      this.condition.actions.tokens=this.querytokenprovider.parseTokens(this.editor,'alert')
      // this.showError = true
      // console.log(this.condition)
    }
//console.log(this.queryValid)
    if(this.condition.actions.condition === 'else'){
      if(this.condition.actions.query.length !=0){
        // if(this.communications.valid){
        //   this.condition.actions.isValid= true
        // }else{
        //   if(!this.communications.pristine && !this.condition.actions.reason && this.condition.actions.reason !=0){
        //     this.condition.actions.isValid=false
        //   }
        // }
        if((this.communications.pristine || this.communications.valid) && (this.condition.actions.reason || this.condition.actions.reason == 0)){
          this.condition.actions.isValid=true
        }else{
          this.condition.actions.isValid= false
        }
      }else{
        this.condition.actions.isValid= true
      }
    }else{
      if(this.communications.valid && this.queryValid && (this.condition.actions.reason || this.condition.actions.reason == 0)){
//console.log("reason->",this.condition.actions.reason)
        this.condition.actions.isValid= true
      }else{
//console.log("<----Actions Invalid----->")
        if(!this.communications.pristine){
          this.condition.actions.isValid=false
        }
      }
    }
    

  }

  phoneValidators(){
    this.phone.get('number').setValidators([this.alertvarservice.phoneNumberValidation()]) 
    this.phone.get('number').updateValueAndValidity()
    // this.phone.get('message').setValidators([Validators.required])
    // this.phone.get('message').updateValueAndValidity()
    this.email.clearValidators()
    this.email.updateValueAndValidity()
  }

  emailValidators(){
    this.email.get('mail_id').setValidators([this.alertvarservice.emailValidator()])
    this.email.get('mail_id').updateValueAndValidity()
    // this.email.get('mail_body').setValidators([Validators.required])
    // this.email.get('mail_body').updateValueAndValidity()
    // this.email.get('subject').setValidators([Validators.required])
    // this.email.get('subject').updateValueAndValidity()
    this.phone.clearValidators()
    this.phone.updateValueAndValidity()
  }

  verifyquery() { // Run Test
    //console.log("Tokens --->",this.querytokenprovider.parseTokens(this.editor))
    // this.alertvarservice.queryVerified=true
    // console.log(">>>>>>>>>>>><<<<<<<<<<", this.query)
    if (!this.query.valid || !this.queryEditorService.get_editor_value(this.editor) || this.queryEditorService.isEditorError(this.editor)) {
      // this.alertvarservice.queryVerified=false
      this.alertvarservice.showError = true
      this.alertvarservice.errorState[1] = true;
      this.alertvarservice.isInvalid = true
      // console.log("Invalid>>>>>.", this.alertvarservice.isInvalid)
      if (this.query.valid) {
        this.errstr = this.alertvarservice.errorType[101];
        // console.log("error>>>>.", this.errstr)
        // console.log("conditions====>>>>>>>>>>", this.query)
      }
    } else {
      // this.alertvarservice.queryVerified=true
      this.alertvarservice.showError = false


      this.enginequery = {}
      // this.enginequery=this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor)['SearchCommand'])
      this.enginequery['SearchCommand'] = this.querytokenprovider.parseTokens(this.editor,'alert')['SearchCommand']

      this.sharedService.runtest({
        "ruleId": this.ruleInfo["alertId"] ? this.ruleInfo["alertId"] : this.ruleInfo["ruleFor"],
        // "platform": this.ruleInfo["platform"],
        // "lastAlertTime": this.ruleInfo["lastAlertTime"],
        "tokens": this.querytokenprovider.parseTokens(this.editor,'alert'),
        "stepsize": this.ruleInfo["stepsize"],
        "timeframe": this.ruleInfo["timeframe"]
      }).subscribe((data) => {
        // console.log(data)
        // this.condition["run_test"] = data
        this.runtest=data

      })
      // console.log("Engine Query",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.editor).searchTokens))
      this.errstr = "";
      this.alertvarservice.isInvalid = false
      // console.log("Invalid>>>>>.", this.alertvarservice.isInvalid)
      this.query.setValue(this.queryEditorService.get_editor_value(this.editor));
      // this.alertvarservice.testResultVolume = this.alertvarservice.testResults.volume.value
      // this.testResultActionable = this.alertvarservice.testResults.actionable.value
      // this.testResultNoise = this.alertvarservice.testResults.noise.value
      this.alertsLabel = this.alertvarservice.ruleTitles.alerts
      this.percentLabel = this.alertvarservice.ruleTitles.percent
    }
    this.selectedItem = this.query.value
    this.alertservice.alertRules.ruleconditions.query = this.selectedItem
    // this.onChange(this.query);

    this.emitValueChange(); // Emit values
  }

  removetagChip_click(tag: any) {
    this.alertvarservice.tagsSet.delete(tag)
    this.tags.get(tag.parent).get(tag.val).setValue(false)
    this.emitValueChange(); // Emit values
  }
  removeChipAlert(tag: any, entityType?: string) {
    // // console.log("Platform",this.platform.value)

    this.tags.patchValue({
      [entityType]: {
        [tag]: false
      }
    })
  }
  // actionclick(action: any) { // Store Action
  //   // console.log({ action })
  //   // this.condition.actions.action = action
  //   // console.log("RuleForm ---->",this.alertvarservice.clickedAction,"\n",this.alertvarservice.clickedState)

  //   // }

  //   this.alertvarservice.clickedAction = action
  //   this.alertvarservice.clickedState = ''
  //   this.alertvarservice.clickedReason = ''
  //   this.alertvarservice.clickedStateReason = ''
  //   // this.alertvarservice.closureAction.no_action_required.state = 0
  //   this.alertvarservice.actionWindow = action
  //   this.actionWindow = action
  //   this.alertvarservice.openComments = false
  //   // this.catClick("0")
  //   // this.reasonClick("0")
  //   // this.stateReasonClick("0")
  //   // this.emitValueChange()
  // }
  // catClick(stateKey) { // Store State
  //   this.condition.actions.state = stateKey

  //   //console.log({stateKey})
  //   // console.log("State Key ---->",stateKey)
  //   // console.log("StateKey----->",this.alertvarservice.mockClosureAction.status[this.alertvarservice.clickedAction].state[stateKey])
  //   this.alertvarservice.clickedState = stateKey
  //   this.emitValueChange()
  //   this.alertvarservice.clickedReason = ''
  //   this.alertvarservice.clickedStateReason = ''
  //   this.alertvarservice.openComments = false
  //   this.reasonClick("0")

  // }
  // reasonClick(reason) { // Store Category
  //   this.condition.actions.category = reason

  //   //console.log({reason})
  //   // console.log("alertvarservice.clickedReason---->",reason)
  //   // // console.log("ReasonKey1----->",this.alertvarservice.mockClosureAction.status[this.alertvarservice.clickedAction].state[this.alertvarservice.clickedState].category[reason])
  //   this.alertvarservice.clickedReason = reason
  //   this.alertvarservice.clickedStateReason = ''
  //   this.alertvarservice.openComments = false
  //   this.stateReasonClick("0")
  //   if (this.query.value.length > 0) {
  //     this.enginequery['SearchCommand'] = []
  //     this.enginequery['SearchCommand'] = this.querytokenprovider.parseTokens(this.editor,'alert')['SearchCommand']

  //   }
  //   this.emitValueChange()
  // }
  // stateReasonClick(stateReason) { // Store Reason
  //   this.condition.actions.reason = stateReason

  //   //console.log({stateReason})
  //   // console.log("Reason Click------->")
  //   this.alertvarservice.clickedStateReason = stateReason
  //   // console.log(this.alertvarservice.clickedAction,"\n",this.alertvarservice.clickedState,"\n",this.alertvarservice.clickedReason,"\n",this.alertvarservice.clickedStateReason)
  //   if (stateReason == 9999) {
  //     this.commentsClick()
  //   }
  //   else {
  //     this.alertvarservice.openComments = false
  //   }

  //   this.emitValueChange()
  // }

  commentsClick() {
    //console.log("Comments Click------->")
    this.alertvarservice.openComments = true
    // this.alertvarservice.clickedStateReason=''
  }

  ngOnDestroy() {

    //console.log("Closure Action Destroyed---->")
    this.condition.actions.isValid=false
    this.queryValid=false
    this.runtest={}
    this.alertvarservice.queryVerified = false
    this.alertvarservice.postError = true
    this.alertvarservice.showError = false
    this.alertvarservice.resetRuleForm()
    this.alertvarservice.clickedAction = ''
    this.alertvarservice.clickedState = ''
    this.alertvarservice.clickedReason = ''
    this.alertvarservice.clickedStateReason = ''
    this.alertvarservice.openComments = false
    Object.keys(this.alertvarservice.closureAction1).forEach(data => {
      this.alertvarservice.closureAction1[data].state = 0
    })
    this.query.setValue('')
    this.queryEditorService.set_editor_value(this.editor, '')

    // this.alertvarservice.closureAction1.flagged_for_review.state=0
    // this.alertvarservice.closureAction1.close.state=0
    // this.alertvarservice.closureAction.no_action_required.state = 1
    this.editor.destroy()
    this.$destroy.next(true);
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

  }


  

  get method(){
    return this.communications.get('method') 
  }

  get phone(){
    return this.communications.get('phone') as UntypedFormGroup
  }
  get number(){
    return this.phone.get('number')
  }

  get email(){
    return this.communications.get('email') as UntypedFormGroup
  }

  get mail_id(){
    return this.email.get('mail_id')
  }

  get subject(){
    return this.email.get('subject')
  }


  createeditor(builtInquery: string, grammar: string) {
    let query = builtInquery.replace(/ AND /g, ' AND\n').replace(/ OR /g, ' OR\n');
    let  id
    if(this.alertvarservice.editState){
      id=this.alertvarservice.editrequested.value.ruleFor
    }else{
      id = this.alertvarservice._alertName.getValue()
    }
    let part=id.split('.')
//console.log({part})
    let partitions=[
      {
      "technology":part[0],
      "vendor_product":part[1],
      "partition_type":part[2],
      "sub_type":null,
      "event_class": null,
      "model_device": null,
      "partition_name": id}
    ]
    if (this.editor) {
      this.editor.destroy();
      //console.log("Destroyed")
    }
    // this.editor = this.queryEditorService.initializeEditor(this.editorContainer.nativeElement, query, this.readonly, grammar, 'alert',partitions, this.editorValueSubject);
    //console.log("RuleConditionEditor>>>>>>>>>>>",this.editor,"BuiltIn \n",this.builtInquery)
    this.editor = this.queryEditorService.initEditorAlertRule(this.editorContainer.nativeElement, this.readonly, grammar, 'alert',this.editableCompartment,partitions, this.editorValueSubject,id);

    this.queryEditorService.set_editor_value(this.editor, this.builtInquery)


  }
  isValid() {
    let editorErr = this.queryEditorService.isEditorError(this.editor)
    this.condition.actions.isValid = editorErr
    return editorErr
  }

  methodClick(value){
    this.method.setValue(value)
  }

  getSelectedItems(value) { // get emitted value from nested dropdown
//console.log({value})
//console.log(this.dropDownIndex)
    // this.condition.action = value
    // if(value.index == this.dropDownIndex){
    this.selectedAction=JSON.parse(JSON.stringify(value))
//console.log(this.selectedAction)
    this.condition.actions.action=this.selectedAction[0].val
    this.condition.actions.state=this.selectedAction[1].val
    this.condition.actions.category=this.selectedAction[2].val
    this.condition.actions.reason=this.selectedAction[3].val

//console.log(this.condition.actions)
    // }

    if(this.condition.actions.condition === 'else'){
      if(this.condition.actions.query.length !=0){
        if(this.communications.valid){
          this.condition.actions.isValid= true
        }else{
          if(!this.communications.pristine ){
            this.condition.actions.isValid=false
          }
        }
      }else{
        this.condition.actions.isValid= true
      }
    }else{
      if(this.communications.valid && this.queryValid){
        this.condition.actions.isValid= true
      }else{
        if(!this.communications.pristine){
          this.condition.actions.isValid=false
        }
      }
    }
    

  }
  restructure(A) {
    const result = [];
//console.log({A})

    for (const [statusKey, statusObj] of Object.entries(A.status)) {
      if(statusObj["disp"] !="New"){
        const statusItem = {
          disp: statusObj["disp"],
          state: 1,
          val: Number(statusKey),
          value: []
        };

        for (const [stateKey, stateObj] of Object.entries(statusObj["state"])) {
          const stateItem = {
            disp: stateObj["disp"],
            state: 1,
            val: Number(stateKey),
            value: []
          };

          for (const [catKey, catObj] of Object.entries(stateObj["category"])) {
            const catItem = {
              disp: catObj["disp"],
              state: 1,
              val: Number(catKey),
              value: []
            };

            for (const [reasonKey, reasonObj] of Object.entries(catObj["reason"])) {
              catItem.value.push({
                disp: reasonObj["disp"],
                state: 1,
                val: Number(reasonKey)
              });
            }

            stateItem.value.push(catItem);
          }

          statusItem.value.push(stateItem);
        }

        result.push(statusItem);
      }
    }

    return result;
  }

  restructureEdit(){
    // console.log(this.mockClosureAction)
//console.group("Restructure on Edit")
// console.log(this.mockClosureAction)
//console.log(this.selectedAction)
// console.log(this.condition.actions)
    let selectedAction=[]
    this.restructure(this.alertvarservice.mockClosureAction).forEach(action=>{
      // console.log({action})
      if(action.val == this.condition.actions.action){
//console.log({action})
        selectedAction.push(action)
        action.value.forEach(state=>{
//console.log(category.val,"->",this.condition.actions.category)
          if(state.val == this.condition.actions.state){
//console.log({category})
            selectedAction.push(state)
            state.value.forEach(category=>{
              if(category.val == this.condition.actions.category){
//console.log({state})
                selectedAction.push(category)
                category.value.forEach(reason=>{
                  if(reason.val == this.condition.actions.reason){
//console.log({reason})
                    selectedAction.push(reason)
                  }
                })
              }
            })
          }
        })
      }
    })
    // console.log({selectedAction})
    this.selectedAction=selectedAction
    this.actionComments=this.condition.actions.comments
//console.log({selectedAction})
//console.groupEnd()
  }

}
